import React from 'react';
import { RouteComponentProps } from 'react-router';
import {
  getUrlParamByName,
  isBlank,
  scrollTo,
  selfEventInstance
} from '@autobest-ui/utils';
import RenderRoutes, { RenderRoutesProps } from './components/renderRoutes';
import Header from './components/header';
import Footer from './components/footer';
import Title from './components/title';
import { SearchEventType, SearchScroll } from './constants/urlSearchType';

export interface AppProps {
  route: RenderRoutesProps;
}

export default class App extends React.Component<
  AppProps & RouteComponentProps
> {
  removeRouteListen: () => void;

  componentDidMount() {
    // 监听router变化，滚动到顶部
    this.removeRouteListen = this.props.history.listen(() => {
      if (!isBlank(getUrlParamByName(SearchScroll))) {
        selfEventInstance.emit(SearchEventType);
        return;
      }
      scrollTo(0, 0, true);
    });
  }

  componentWillUnmount() {
    this.removeRouteListen();
  }

  render() {
    return (
      <React.Fragment>
        <Title />
        <Header />
        <div style={{ position: 'relative', minHeight: '85vh' }}>
          <RenderRoutes routes={this.props.route.routes} />
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
